<template>
  <div>
    <h1 class="mb-0 text-center">
      <span style="color:#ff5a00; font-weight: bold;">123</span><span style="margin: 0">GOM</span>
    </h1>
    <p class="text-center text-dark">Đăng nhập hệ thống</p>
        <sign-in1-form formType="jwt" username="" password=""></sign-in1-form>
  </div>
</template>

<script>
import SignIn1Form from './Forms/SignIn1Form'

export default {
  name: 'SignIn1',
  components: { SignIn1Form },
  data: () => ({}),
  mounted () {
  }
}
</script>
